
import { useState, useEffect } from 'react';

export function useSidebarState() {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(
    localStorage.getItem('sidebar-collapsed') === 'true' || false
  );

  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', isCollapsed.toString());
  }, [isCollapsed]);

  return {
    isCollapsed,
    setIsCollapsed,
    toggleSidebar: () => setIsCollapsed(prev => !prev)
  };
}
